import Unsplash from "unsplash-js";

const unsplash = new Unsplash({
  applicationId: "2871e5f6ee0121970231c7878024ba54f7a5987de78867c14c9b6dcba54670ae",
  secret: "842f14fdc15afaefac88d191603c2ec54a4182e0c4de5248133d96da17c85139"
});

export default unsplash;